import { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import AnimeCard from '@/components/base/AnimeCard';
import { categoryMap, categories } from '@/mocks/category';
import { animeList } from '@/mocks/anime';

export default function CategoryDetail() {
  const { slug } = useParams<{ slug: string }>();

  const category = slug ? categoryMap[slug] : undefined;
  const filteredAnime = useMemo(() => {
    if (!slug) return [];
    return animeList.filter((a) => a.category === slug);
  }, [slug]);

  const otherCategories = useMemo(() => {
    return categories.filter((c) => c.slug !== slug).slice(0, 4);
  }, [slug]);

  if (!category) {
    return (
      <Layout>
        <div className="pt-24 pb-14">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center py-20">
            <p className="text-foreground-500">分类不存在</p>
            <Link to="/categories" className="mt-4 inline-block text-primary-500 hover:text-primary-600 text-sm cursor-pointer">
              返回分类列表
            </Link>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="pt-24 pb-14">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '分类浏览', path: '/categories' },
              { label: category.name },
            ]}
          />

          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                <i className={`${category.icon} text-primary-600 text-lg`}></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-950">{category.name}</h1>
            </div>
            <p className="text-sm text-foreground-500">{category.description}</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5 mb-14">
            {filteredAnime.map((anime) => (
              <AnimeCard key={anime.id} anime={anime} />
            ))}
          </div>

          {filteredAnime.length === 0 && (
            <div className="text-center py-20">
              <p className="text-foreground-500">该分类下暂无内容</p>
            </div>
          )}

          <div className="border-t border-background-200 pt-10">
            <h3 className="text-lg font-heading text-foreground-950 mb-4">探索其他分类</h3>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {otherCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-2 p-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
                >
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
                    <i className={`${cat.icon} text-accent-600 text-sm`}></i>
                  </div>
                  <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">{cat.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}